/**
 * Use Case: Fetch Programs
 * Business logic for fetching programs data.
 */

import type {
  FetchProgramsParams,
  ProgramItem,
  ProgramsPaginatedResult,
} from "../model/ProgramsModel";
import type { IProgramsRepository } from "../repository/IProgramsRepository";
import { programsContainer, TYPES } from "../../di/ProgramsModule";

export type FetchProgramsResult = {
  readonly items: readonly ProgramItem[];
};

/**
 * Fetch all programs (backwards-compatible, non-paginated).
 */
export const FetchProgramsUseCase = async (): Promise<FetchProgramsResult> => {
  const repository = programsContainer.get<IProgramsRepository>(
    TYPES.IProgramsRepository,
  );
  const items = await repository.fetchAll();

  return { items };
};

/**
 * Fetch programs with pagination and optional filters.
 */
export const FetchProgramsPaginatedUseCase = async (
  params: FetchProgramsParams = {},
): Promise<ProgramsPaginatedResult> => {
  const repository = programsContainer.get<IProgramsRepository>(
    TYPES.IProgramsRepository,
  );

  return repository.fetchPaginated(params);
};
